import { useState, useCallback } from 'react';
import { User } from '../types/User';
import { ModalTypeUser } from '../types/ModalTypeUser';

interface UseUserModalsProps {
    fetchUsers: () => void;
    fetchOwners: (page: number, pageSize: number) => void;
    selectedStateMenuUsers: string;
    setSelectedRowKeys2: (keys: any[]) => void;
    users: User[];
}

const useUserModals = ({
    fetchUsers,
    fetchOwners,
    selectedStateMenuUsers,
    setSelectedRowKeys2,
    users,
}: UseUserModalsProps) => {
    const [activeModal, setActiveModal] = useState<ModalTypeUser>(ModalTypeUser.NONE);
    const [selectedUser, setSelectedUser] = useState<User | null>(null);

    const handleModalOk = useCallback(() => {
        setActiveModal(ModalTypeUser.NONE);
        setSelectedRowKeys2([]);

        if (
            activeModal === ModalTypeUser.ADD_OWNER ||
            (activeModal === ModalTypeUser.DELETE_USER && selectedStateMenuUsers === 'owners')
        ) {
            fetchOwners(1, 10000);
        } else {
            fetchUsers();
        }
    }, [fetchUsers, fetchOwners, activeModal, selectedStateMenuUsers, setSelectedRowKeys2]);

    const handleModalCancel = useCallback(() => {
        setActiveModal(ModalTypeUser.NONE);
    }, []);

    const handleDeleteAction = useCallback(() => {
        setActiveModal(ModalTypeUser.DELETE_USER);
    }, []);

    const handleUpdateAction = useCallback((user?: User) => {
        setActiveModal(ModalTypeUser.UPDATE_USER);
        if (user) setSelectedUser(user);
    }, []);

    const handleEditAction = useCallback(() => {
        setActiveModal(ModalTypeUser.EDIT_USER);
    }, []);

    return {
        activeModal,
        setActiveModal,
        handleModalOk,
        handleModalCancel,
        handleEditAction,
        handleDeleteAction,
        handleUpdateAction,
        setSelectedUser,
        selectedUser,
    };
};

export default useUserModals; 